import { html, ref } from '@microsoft/fast-element';
import { AllContractsGraph } from './all-contracts-graph';

export const AllContractsGraphTemplate = html<AllContractsGraph>`
  <div
    style="display: ${(x) => (x.showGraph ? 'block' : 'none')}"
    class="all-contracts-graph"
    style=""
    ${ref('allcontractsGraph')}
  ></div>
  <div style="display: ${(x) => (x.showGraph ? 'none' : 'flex')}" class="no-data-message">
    <div class="header">No Set Preferences Selected</div>
    <div>Select and Confirm Set Preferences to view All Contract results</div>
  </div>
`;
